



















































import { Component, Watch } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import Simulation from '@/models/Accounts/Shared/Toolkit/Simulation';

@Component({ name: 'NewSimulationTool' })
export default class extends SaascadaVueDialog {

    dialog: boolean = false;
    newSimulation: Simulation = new Simulation();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.newSimulation = new Simulation();
        }
    }

    close() {
        this.dialog = false;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await LendingAccountModule.createNewSimulation(this.newSimulation);
        }
    }


};
